import { useField } from "formik";

import PhoneNumberInput from "./PhoneNumberInput";

const FormikPhoneNumberInput = ({ name, ...props }) => {
  const [field, meta, { setValue }] = useField(name);

  return (
    <PhoneNumberInput
      {...field}
      error={meta.touched ? meta.error : ""}
      onChange={setValue}
      {...props}
    />
  );
};

export default FormikPhoneNumberInput;
